import React, { useCallback, useEffect, useState } from 'react'
import { DatePickerFormFieldInline } from 'components/Shared/DatePickerInline'
import { PriceFields } from 'components/Contractors/InsurancePolicy/Form/PriceFields'
import LabeledCheckboxField from 'components/Shared/LabeledCheckboxField/LabeledCheckboxField'
import styles from 'components/Contractors/InsurancePolicy/Form/InsurancePolicyForm.module.css'
import { FieldArray, useFormikContext } from 'formik'
import { times } from 'lodash'
import { useTranslation } from 'react-i18next'

function round (number) {
  return Math.round((number + Number.EPSILON) * 100) / 100
}

export function ContributionsFieldsList ({ disabled }) {
  return <FieldArray
    name={'contributionsDetails.contributions'}
    render={arrayHelpers => (
      <ContributionsFieldsContainer arrayHelpers={arrayHelpers} disabled={disabled}/>
    )}
  />
}

function ContributionsFieldsContainer ({ arrayHelpers, disabled }) {
  const { values, setFieldValue } = useFormikContext()
  const contributionsCount = values.contributionsDetails.count
  const contributionsAmount = values.contributionsDetails.amount
  const contributionsCurrencyCode = values.contributionsDetails.currencyCode
  const [previousContributionsCount, setPreviousContributionsCount] = useState(contributionsCount)

  const updateContributionsAmount = useCallback(() => {
    times(contributionsCount, i => {
      const itemToUpdate = values.contributionsDetails.contributions[i]
      if (itemToUpdate)
        arrayHelpers.replace(i, {
          ...itemToUpdate,
          amount: {
            ...itemToUpdate.amount,
            amount: round(contributionsAmount / contributionsCount)
          }
        })
    })
  }, [contributionsCount, contributionsAmount, arrayHelpers, values])

  useEffect(() => {
    if (contributionsCount !== previousContributionsCount) {
      if (contributionsCount > previousContributionsCount) {
        times(contributionsCount - previousContributionsCount, i => arrayHelpers.push({
          confirmationDate: null,
          paymentDate: null,
          amount: {
            amount: round(contributionsAmount / contributionsCount),
            currencyCode: contributionsCurrencyCode
          },
          isPaid: false,
          ordinalNumber: contributionsCount + i
        }))
      } else if (contributionsCount < previousContributionsCount) {
        times(previousContributionsCount - contributionsCount, () => arrayHelpers.pop())
      }
      updateContributionsAmount()
      setPreviousContributionsCount(contributionsCount)
    }
  }, [previousContributionsCount, contributionsCount, contributionsAmount, contributionsCurrencyCode, arrayHelpers, updateContributionsAmount])

  useEffect(() => {
    for (let i = 0; i < contributionsCount; i++) {
      setFieldValue(`contributionsDetails.contributions[${i}].amount.currencyCode`, contributionsCurrencyCode)
    }

  }, [contributionsCurrencyCode, contributionsCount, setFieldValue])

  return times(contributionsCount, i => <ContributionFields key={i} index={i} disabled={disabled}/>)
}

function ContributionFields ({ index, disabled }) {
  const fieldNameBase = `contributionsDetails.contributions[${index}]`
  const { t } = useTranslation()

  return <>
    <PriceFields amountFieldName={`${fieldNameBase}.amount.amount`}
                 amountLabel={t('insurancePolicy.form.contributionsDetails.contribution.amount', { number: index + 1 })}
                 currencyCodeFieldName={`${fieldNameBase}.amount.currencyCode`}
                 currencyCodeLabel={'insurancePolicy.form.contributionsDetails.contribution.currencyCode'}
                 disabled={disabled}
                 currencyLocked={true}/>
    <DatePickerFormFieldInline name={`${fieldNameBase}.confirmationDate`}
                               label={'insurancePolicy.form.contributionsDetails.contribution.confirmationDate'}
                               clearable
                               disabled={disabled}/>
    <DatePickerFormFieldInline name={`${fieldNameBase}.paymentDate`}
                               label={'insurancePolicy.form.contributionsDetails.contribution.paymentDate'}
                               clearable
                               disabled={disabled}/>
    <LabeledCheckboxField className={styles.checkboxContainer}
                          fieldName={`${fieldNameBase}.isPaid`}
                          label={'insurancePolicy.form.contributionsDetails.contribution.isPaid'}
                          disabled={disabled}/>
  </>
}
